<template>
  <!-- CARD 4: SESSION -->
  <div class="vx-col w-full mb-base">
    <vx-card>
      <div class="vx-row flex-col-reverse md:flex-col-reverse sm:flex-row lg:flex-row">
        <!-- LEFT COL -->
        <div class="vx-col w-full md:w-full sm:w-1/2 lg:w-1/2 xl:w-1/2 flex flex-col justify-between" v-if="salesBarSession.analyticsData">
          <div>
            <risk-model-result
              ref="result"
              :score="score"
              :high-config="[60, 100]"
              :medium-config="[40, 59]"
              :low-config="[0, 39]"
              v-model="resultColor"
            />

            <vs-chip
              style="font-size: 14px"
              class="font-black"
              v-if="qualification"
              :color="resultColor">
              Calificación RG: {{qualification.qualification}}
            </vs-chip>

          </div>
          <vs-button
            @click.native="updateInterestRateHandler(qualification)"
            v-if="projectData.finance.qualification !== qualification.qualification"
            color="danger"
            icon-pack="feather"
            icon="icon-chevrons-right"
            icon-after
            class="shadow-md w-full lg:mt-0 mt-4">
            Aplicar nueva tasa de interés
          </vs-button>
        </div>

        <!-- RIGHT COL -->
        <div class="vx-col w-2/12 flex flex-col lg:mb-0 md:mb-base sm:mb-0 mb-base">
          <vue-apex-charts
            type="bar"
            id="approveModelRiskChart"
            height="200"
            :options="salesBarSession.chartOptions"
            :series="salesBarSession.series"
            v-if="salesBarSession.series" />
        </div>

        <div class="flex-auto mt-5">
          <apex-custom-label
            :color="salesBarSession.chartOptions.colors[i]"
            :title="c"
            v-for="(c, i) in salesBarSession.chartOptions.xaxis.categories"></apex-custom-label>
        </div>
      </div>

    </vx-card>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import {fixNumber} from "@/filters/NumberFilters";
import RiskModelResult from "@views/admin/RiskModel/Dashboard/RiskModel/Components/RiskModelResult";
import ApexCustomLabel from "@views/admin/RiskModel/Dashboard/RiskModel/ApexCustomLabel";

export default {
  name: "ModelRiskAnalytics",
  components: {
    ApexCustomLabel,
    RiskModelResult,
    VueApexCharts,
  },
  props: {
    projectData: {
      type: Object,
      required: true
    },
    qualification: {
      type: Object
    },
    score: {
      type: Number,
      required: true
    },
    project: {
      type: Number,
      required: true,
      default: 0
    },
    capacityPayment: {
      type: Number,
      required: true,
      default: 0
    },
    personalProfile: {
      type: Number,
      required: true,
      default: 0
    },
    scoreAndBehaviour: {
      type: Number,
      required: true,
      default: 0
    }
  },
  filters: {
    fixNumber,
  },
  data () {
    return {
      resultColor: "",
      salesBarSession:  {
        chartOptions: {
          xaxis: {
            categories: ['Proyectos', 'Perfil: Personales', 'Reputación y comportamiento', 'Capacidad de Pago']
          },
          grid: {
            show: false,
            padding: {
              left: 0,
              right: 0
            }
          },
          chart: {
            id: 'basic-bar',
            type: 'bar',
            barHeight: '100%',
            sparkline: { enabled: true },
            toolbar: { show: false },
            height: 350
          },
          states: {
            hover: {
              filter: 'none'
            }
          },
          colors: ['rgb(255,193,7)', 'rgb(68,138,255)', 'rgb(40,199,111)', 'rgb(115,103,240)', 'rgba(115,103,240,0.15)'],
          plotOptions: {
            bar: {
              columnWidth: '45%',
              distributed: true,
              endingShape: 'rounded',
              horizontal: false,
              dataLabels: {
                enabled: false
              },
            }
          },
          tooltip: {
            x: { show: true }
          }
        },
        series: [
          {
            name: 'Resultado',
            data: [this.project, this.personalProfile, this.scoreAndBehaviour, this.capacityPayment]
          }
        ],
        analyticsData: {
          session: 52,
          comparison : {
            str: 'Last 7 Days',
            result: +5.2
          }
        }
      }
    }
  },
  methods: {
    async updateInterestRateHandler(qualification) {
      if (confirm("Al aplicar la nueva tasa de interés modificará los datos financieros y tabla de amortización. ¿Desea continuar?")) {
        try {
          const {data} = await axios.put(`/api/v1/projects/${this.projectData.id}/change-interest-rate`, qualification)
          this.projectData.finance.qualification = data.qualification;
          swal("Notificación", "La tasa de interés se aplico correctamente.", "success")
        } catch(err) {
          swal("Error", err.response.data.error, "error")
        }
      }

    }
  }
}
</script>
